// extracted by mini-css-extract-plugin
module.exports = {"view_switcher_container":"product-filter-layout_view_switcher_container__JAp1s","active_view_switcher":"product-filter-layout_active_view_switcher__FAtaq"};